import { useState } from 'react';

import ELEMENT from 'common/element';

import Button from 'components/common/Button/Button';
import DropdownItems from 'components/common/DropdownItems/DropdownItems';
import OverlayTrigger from 'components/common/OverlayTrigger/OverlayTrigger';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

type DropdownSelectProps = {
  values: string[];
  currentValue: string;
  callback: (value: string) => void;
  testId?: ELEMENT;
};

function DropdownSelect({ values, currentValue, callback, testId }: DropdownSelectProps): JSX.Element {
  const [showOverlay, setShowOverlay] = useState(false);

  const sections = [
    values.map((value) => ({
      text: value.toString(),
      clickHandler: (): void => callback(value),
      testId: testId + value,
    })),
  ];

  return (
    <OverlayTrigger
      overlay={
        <div className="Dropdown__Menu">
          <DropdownItems close={(): void => setShowOverlay(false)} sections={sections} />
        </div>
      }
      placement="bottom-start"
      className="IconMenu__VertOverlay"
      showOverlay={showOverlay}
      setShowOverlay={setShowOverlay}
    >
      <Button rightIcon={<ArrowDropDownIcon fontSize="small" />} testId={testId}>
        {currentValue}
      </Button>
    </OverlayTrigger>
  );
}

export default DropdownSelect;
